export const submitKeycloakAction = ({ formData, action } = {}) => {
    const form = document.createElement("form");
    form.style.display = "none";
    form.hidden = "hidden";
    if (formData){
        Object.entries(formData).forEach(([ key, val ]) => {
            const input = document.createElement("input");
            input.name = key;
            input.id = key;
            input.value = val;
            input.type = "text";
            form.appendChild(input);
        });
          
    }
    const submit = document.createElement("input");
    submit.type = "submit";
    form.appendChild(submit);
    document.body.appendChild(form);
    form.action = action;
    form.method = "POST";
    form.submit();    
};

